export function createCustomFetch({ baseURL, defaultHeaders = {} }) {
  const request = async (method, url, data = null, options = {}) => {
    const finalURL = `${options.baseURL || baseURL}${url}`
    const headers = {
      ...defaultHeaders,
      ...options.headers,
    }
    if (headers.excludeAuth) {
      delete headers.Authorization
    }
    delete headers.excludeAuth

    if (!(data instanceof FormData)) {
      headers['Content-Type'] = 'application/json'
    }

    const fetchOptions = {
      method,
      headers,
      ...(options?.headers?.cache
        ? { next: { revalidate: 3600 } }
        : { cache: 'no-store' }),
    }

    if (data && method !== 'GET') {
      fetchOptions.body = data instanceof FormData ? data : JSON.stringify(data)
    }

    const res = await fetch(finalURL, fetchOptions)
    let resData = {}
    if (method !== 'DELETE') {
      resData = await res.json()
      if (!res.ok) throw resData
    }
    if (!res.ok) {
      const errorData = await res.json()
      throw errorData
    }
    return resData
  }

  return {
    get: (url, options = {}) => request('GET', url, null, options),
    post: (url, data, options = {}) => request('POST', url, data, options),
    put: (url, data, options = {}) => request('PUT', url, data, options),
    delete: (url, data = {}, options = {}) =>
      request('DELETE', url, data, options),
  }
}
